module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-pulse-desktop-bg-a8aae71f2cb63442b6717b6b63718408.png";